import request from "@/utils/request";
import md5 from 'js-md5'
import QS from 'qs'
import { sortASCII } from '@/utils'
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 添加预约
export function insertOrder (data) {
  return request({
    url: GateWay + "/monthUser/insertOrder",
    method: "post",
    data
  });
}

